export default {
    orderNewPatch: {
        Status: '状态',
        oStatus: '订单状态',
        wmsStatus: '处理状态',
        Editing: '编辑中',
        editSuccessful:'编辑成功',
        editFailed:'编辑失败',
        Cancelling: '取消中',
        cancelSuccessful:'取消成功',
        cancelFailed:'取消失败',
        order: '订单号',
        Import: '导入',
        CustomerOrder: '客户订单号',
        Reason: '异常类型',
        Detail: '异常详情',
        Ordered: '平台下单时间',
        Created: 'ERP 接单时间',
        WMSSyncTime: '推送仓库时间',
        Uploaded: '更新时间',
        pickup: '拣货时间',
        Information: '订单基本信息',
        Receiver: '收货人信息',
        ReceiverNotes: '收货人备注',
        Product: '产品名称',
        Shipping: '邮寄方式',
        ShippingCost: '总运费',
        Courier: '物流公司',
        Reprocess: '重新推单',
        lock: 'WMS锁定时间',
        delivery: 'WMS发货时间',
        filePs1: '1.请在此处更新发货标签,最大5MB',
        filePs2: '2.请使用快递号作为文件名',
        orderDate: '平台下单时间',
        creationDate: 'ERP创建时间',
        sapPushTime: 'HJ创建时间',
        hjShipmentTime: 'HJ关单时间',
        receiveTime: 'ERP关单时间',
    }
};
